import { resolveTenantDatabaseName } from "../../../utils/resolveTenantDatabaseName";

/**
 * Ativa o workspace no cliente (header Company = schema MySQL) e abre o app principal.
 * Usado pelo portal revenda (JWT scope=partner) e pelo console da plataforma (master/ops).
 * Ao excluir o workspace correspondente, limpe o storage com `clearStoredWorkspaceIfExcluded` em `utils/workspaceLocalStorage`.
 *
 * @param {import("react-router-dom").NavigateFunction} navigate
 * @param {string | null | undefined} bd Nome do schema em dominios.bd (pode estar vazio; apresentação infere de *.xpro.me)
 * @param {string | null | undefined} dominioHost Host do workspace (ex.: sub.xpro.me), usado quando bd vem vazio
 */
export function openWorkspaceInApp(navigate, bd, dominioHost) {
  const slug = resolveTenantDatabaseName(dominioHost, bd);
  if (!slug) return;
  try {
    localStorage.setItem("company", slug);
    localStorage.setItem("xproWorkspaceDatabase", slug);
    sessionStorage.setItem("activeCompany", slug);
  } catch {
    /* ignore */
  }
  navigate("/chat");
}
